import { useTranslation } from 'react-i18next';

export function SplashScreen() {
  const { t } = useTranslation();
  return (
    <div className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[#0d1b2a]">
      {/* Logo image forced white via mix-blend-mode + background trick */}
      <div className="mb-4 relative w-24 h-24 flex items-center justify-center">
        <img
          src="/logo512.png"
          alt="VisaConnect"
          className="w-20 h-20"
          style={{
            filter: 'brightness(0) invert(1)',
            WebkitFilter: 'brightness(0) invert(1)',
          }}
        />
      </div>
      <p className="text-white font-bold text-2xl tracking-wide">VisaConnect</p>
      <p className="text-white text-xs tracking-widest uppercase mt-2 opacity-80">
        {t('splash.tagline')}
      </p>
      <div className="absolute bottom-12 w-32 h-0.5 bg-white/30 rounded-full overflow-hidden">
        <div
          className="h-full bg-white rounded-full"
          style={{ animation: 'splashLoad 1.5s ease-in-out forwards' }}
        />
      </div>
      <style>{`
        @keyframes splashLoad {
          from { transform: translateX(-100%); }
          to { transform: translateX(0%); }
        }
      `}</style>
    </div>
  );
}
